import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { Observable, Subscription, forkJoin} from 'rxjs';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { GenericLambdaReturn } from '../models/genericLamba';
import { EnterpriseViewService, EnterpriseType } from '../services/enterprise-view.service';
import { LocationInformationService } from '../services/location-information.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LoadingService } from '../services/loading.service';
import { DateSelectionComponent } from '../date-selection/date-selection.component';
import { SaveAsCsvComponent } from '../save-as-csv/save-as-csv.component';
import { MatSort } from '@angular/material/sort';
import { NgClass, DecimalPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
    selector: 'app-enterprise-view',
    templateUrl: './enterprise-view.component.html',
    styleUrls: ['./enterprise-view.component.scss'],
    imports: [DateSelectionComponent, SaveAsCsvComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, RouterLink, NgClass, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DecimalPipe]
})
export class EnterpriseViewComponent implements OnInit, OnDestroy {
  dataSource:MatTableDataSource<EnterpriseType>
  mDataSource: EnterpriseType[]
  subscription: Subscription;
  currentShift: string = "True";
  enterpriseDataArr: any[];
  dateString: string;

  enterpriseViewDataSource: MatTableDataSource<EnterpriseType> = new MatTableDataSource<EnterpriseType>();

  enterpriseViewData$: Observable<EnterpriseType[]>

  public fromDateString: string;
  public toDateString: string;

  fg_hdr: FormGroup = new FormGroup('');
  manualInput: boolean = false;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['site', 'minor', 'major', 'critical', 'Acknowledged','total', 'score', 'trendChartButton'];

  constructor(
    private service: EnterpriseViewService,
    private route: ActivatedRoute,
    private locationInformationService: LocationInformationService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(){
    setTimeout(() => {
      if (this.fromDateString && this.toDateString) {
        this.fetch();
      }
    });
    setTimeout(() => 
      {this.locationInformationService.changeLocation(true);
      this.locationInformationService.changePlantView(false);
      this.locationInformationService.changePlant('');
      this.locationInformationService.changeDetailsView(false);
      this.locationInformationService.changeSeverityView(false);
    })

    this.dataSource = new MatTableDataSource<EnterpriseType>();
  }

  fetch(){
    this.loadingService.show();
      let d: Observable<GenericLambdaReturn<EnterpriseType[]>> =
      this.route.paramMap.pipe(
        switchMap((params:ParamMap) =>
        this.service.getEnterpriseData(this.currentShift, this.fromDateString + ' 00:00:00', this.toDateString + ' 23:59:59.999',))
      );
    
      if (this.subscription) this.subscription.unsubscribe();
    
    this.subscription = d.subscribe({
      next:(next) => {
      this.dataSource.data=next.Body;
      this.mDataSource = next.Body;
      this.enterpriseDataArr = next.Body;
      this.dateString = this.fromDateString + '-' + this.toDateString;
      this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide(); // also hide on error
      }
    })
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }


  changePlant(plant: string){
    this.locationInformationService.changePlant(plant)
    this.locationInformationService.changePlantView(true)
  }  

  onDateChange(e: any) {
    this.fromDateString = e.fromDate;
    this.toDateString = e.toDate;
    this.currentShift = e.currentShift;

    this.fetch();
  }

}
